const topnav = document.querySelector('.block-topnav');
const mobileTopnav = topnav.cloneNode(true);

mobileTopnav.classList.add('block-topnav--mobile');

document.querySelector('.block-navigation__menu').appendChild(mobileTopnav);
